import React from 'react';
import { Link } from 'react-router-dom';
import { useDashboardData } from 'dsoa-components';

const Adi12DashboardPanel = () => {
  const dashboardData = useDashboardData();

  if (dashboardData.activeTab === 'REGISTER') {
    return null;
  }

  return (
    <>
      {dashboardData.adi12EnrollmentLetters.length > 0 && (
        <div className="ui segment">
          <h3 className="ui header" style={{ textAlign: 'center' }}>
            12 Hour Advanced Driver Improvement
          </h3>
          <div className="ui divider"></div>
          <div className="ui relaxed divided list">
            {dashboardData.adi12EnrollmentLetters.map((letter, index) => (
              <div className="item" key={index}>
                <div className="content">
                  <div className="description">
                    <h4 className="ui header">
                      Enrollment Date:{' '}
                      {new Date(letter.dateCreated).toLocaleDateString()}
                    </h4>
                    <div
                      className="ui stackable two column grid"
                      style={{ marginTop: '10px' }}
                    >
                      <div className="column">
                        <Link
                          to={`/adi12dashboard/${letter.uceId}`}
                          className="ui primary button"
                          style={{
                            width: '100%',
                            display: 'inline-block',
                            textAlign: 'center',
                          }}
                        >
                          <i
                            className="pencil icon"
                            style={{ marginLeft: '4px' }}
                          ></i>
                          View Scenario Answers
                        </Link>
                      </div>
                      <div className="column">
                        <a
                          href={`https://static-content.fedsafe.com/student-certificates/${letter.path}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button
                            className="ui primary button"
                            style={{ width: '100%' }}
                          >
                            <i
                              className="download icon"
                              style={{ marginLeft: '4px' }}
                            ></i>
                            Download Course Enrollment Letter
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Adi12DashboardPanel;
